import { Component, OnInit } from '@angular/core';
import { Alert, Dialog, ColorText, Icon, AlertType } from './snack-bar.model';
import { SnackBarService } from './snack-bar.service';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss']
})

export class SnackBarComponent implements OnInit {

  alert: Alert;
  dialog: Dialog;

  constructor(private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.alert = new Alert();
    this.dialog = new Dialog();

    this.snackbarService.getAlert().subscribe((alert: Alert) => {
      if (!alert) {
        this.alert.messages = [];
        return;
      }
      this.alert = alert;
    });

    /** Dialog */
    this.snackbarService.getDiag().subscribe((dialog: Dialog) => {
      if (!dialog) {
        this.dialog.message = '';
        return;
      }
      this.dialog = dialog;
    });
  }

  onCloseMsg() {
    this.removeAlert();
  }

  removeAlert() {
    this.alert.messages = [];
  }

  getCssClassMsg() {
    if (!this.alert) {
      return;
    }

    switch (this.alert.type) {
      case AlertType.success:
        return this.alert.messages.length > 0 ? 'view-snackbar success' : 'success';
      case AlertType.error:
        return this.alert.messages.length > 0 ? 'view-snackbar danger' : 'danger';
      case AlertType.info:
        return this.alert.messages.length > 0 ? 'view-snackbar info' : 'info';
      case AlertType.warning:
        return this.alert.messages.length > 0 ? 'view-snackbar warning' : 'warning';
    }
  }

  getIconMsg() {
    if (!this.alert) {
      return;
    }
    switch (this.alert.icon) {
      case Icon.success:
        return 'check';
      case Icon.error:
        return 'clear';
      case Icon.info:
        return 'info';
      case Icon.warning:
        return 'warning';
    }
  }

  /** Dialog */
  onNoDiag() {
    this.removeDialog();
  }

  onSiDiag() {
    this.dialog.event();
    this.removeDialog();
  }

  removeDialog() {
    this.dialog.message = '';
  }

  getCssClassDiag() {
    return String(this.dialog.message != '' ? 'view-snackbar' : '');
  }

  getColorText() {
    if (!this.dialog) {
      return;
    }

    switch (this.dialog.colorText) {
      case ColorText.green:
        return 'text-green-dialog';
      case ColorText.red:
        return 'text-red-dialog';
    }
  }
}
